import '../../../scss/styles.scss';

import React from 'react';
import {Profiler} from "../../components/profiler";
import {AppModuleRouterContainer, AppModuleRouterContainerComponentProps} from "./app.module-router-container";
import {Compose, ComposeSettings} from "../../components/composers/compose";
import {AppController} from "../app-controller";
import {AppModuleProps} from "../models/app-module.props";
import {Provider} from "mobx-react";
import {AppStore} from "../app-store";
import {UserAgentViewModel} from "../../models/user-agent.view-model";
import {ThemeContext} from "../contexts/theme-context";
import {THEME} from "../consts";

class AppModuleComponentProps extends AppModuleProps {
  userAgent: UserAgentViewModel;
}

const AppModuleComponent = ({controller, userAgent}: AppModuleComponentProps) => {
  const {state} = controller;
  const appStore: AppStore = controller.store;
  const providerProps = {
    appStore,
    device: controller.device,
  }

  const appModuleRouterContainerProps: AppModuleRouterContainerComponentProps = {
    state,
    controller,
    i18n: controller.state.terms,
    userAgent: userAgent
  }

  return (
    <Profiler id="Main">
      <ThemeContext.Provider value={appStore.state.theme || THEME.LIGHT}>
        <Provider {...providerProps}>
          <AppModuleRouterContainer {...appModuleRouterContainerProps} />
        </Provider>
      </ThemeContext.Provider>
    </Profiler>
  );
}

const settings: ComposeSettings = {
  component: AppModuleComponent,
  propsType: AppModuleComponentProps,
  controllerType: AppController,

  observe: true,
  createModule: true,
  injectUserAgent: true,
}

export default Compose(settings);
